import '../scss/app.scss';
import 'bootstrap';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'chosen-js/chosen.min.css';
import 'daterangepicker/daterangepicker.css';
import 'timepicker/jquery.timepicker.min.css';
import 'ekko-lightbox/dist/ekko-lightbox.css';

import jQuery from 'jquery'; // included via CDN
import zxcvbn from 'zxcvbn'; // included via CDN

// jQuery plugins
import 'chosen-js';
import 'croppie';
import 'daterangepicker';
import 'slick-carousel';
import 'timepicker';
import './plugins/bootstrap-uploadprogress';
import './plugins/multi-step-modal';

import 'url-search-params-polyfill';
import intlTelInput from 'intl-tel-input';

import List from 'list.js';

import 'ekko-lightbox'; // jquery plugin built on top of bootstrap modal

// these have to be global ATM because we use them in the Vue components via script tags in the HTML files
import moment from 'moment-timezone';
global.moment = moment;
import axios from 'axios';
global.axios = axios;
import Vue from 'vue';
global.Vue = Vue;
import _ from 'underscore';
global._ = _;
import imagesLoaded from 'imagesloaded';
global.imagesLoaded = imagesLoaded;
global.$ = jQuery;

import FamilyPhotos from './modules/photos';
import StbManagement from './modules/stbManagement';

// @todo Replace/rebuild scripts from this page

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var ODESSA = {
    // All pages
    common: {
      init: function () {
        // @todo: check for block attributes

        // set overflow: hidden on the body when the mobile nav is open to prevent scrolling under the menu
        const navbarToggler = document.querySelector('.navbar-toggler');
        const body = document.querySelector('body');
        const sidebarToggle = document.querySelector('#sidebarToggle');
        if (navbarToggler) {
          navbarToggler.addEventListener('click', () => {
            if (sidebarToggle.classList.contains('show')) {
              body.classList.remove('overflow-hidden');
            } else body.classList.add('overflow-hidden');
          });
        }

        if ($('.network-selector li').length) {
          $('.network-selector .current-network').addClass('enabled');
        }

        $('.search-toggle').on('click', function (e) {
          e.preventDefault();
          $(this).parent().addClass('open');
        });

        $('.navbar-toggle').on('click', function (e) {
          e.preventDefault();

          $('nav.primary-nav').toggleClass('open');

          if ($('nav.primary-nav').hasClass('open')) {
            $('body').addClass('noscroll');
            $('nav.primary-nav .navbar').before($('.page-header .nav-user').clone());
            $('nav.primary-nav .nav-user .dropdown-menu').addClass('mobile-user-nav');
          } else {
            $('body').removeClass('noscroll');
            $('nav.primary-nav .nav-user').remove();
          }
        });

        $(document).on('click', function (event) {
          if ($('.nav-user .search').hasClass('open')) {
            var $trigger = $('.nav-user .search');
            if ($trigger !== event.target && !$trigger.has(event.target).length) {
              $trigger.removeClass('open');
            }
          }
        });

        $('.navbar .has-children > a').on('click', function (e) {
          e.preventDefault();

          if (!$(this).parent().hasClass('active')) {
            $(this).parent().toggleClass('open');
          }
        });

        $('[data-toggle="collapse"]').on('click', function () {
          $(this).toggleClass('open');
        });

        $('.network-selector').on('click', '.current-network', function (e) {
          if ($('.network-selector li').length) {
            e.preventDefault();
            e.stopPropagation();

            var $clickDetect = $('<div class="click-detect"></div>');
            $clickDetect.width($(window).width()).height($(window).height());
            $('.primary-nav').append($clickDetect);
            $clickDetect.on('click', function () {
              $('.network-selector').removeClass('open');
              $(this).off().remove();
            });
            $('.network-selector').toggleClass('open');
          }
        });

        $('.chosen-select').each(function () {
          var placeholder = $(this).data('placeholder') || 'Choose an option';
          $(this).chosen({
            width: '100%',
            placeholder_text_single: placeholder,
          });
        });

        $('form.uploadprogress').uploadprogress({
          redirect_url: $('form.uploadprogress').data('success-url'),
        });

        $('.inputfile').each(function () {
          var $input = $(this),
            $label = $input.next('label'),
            labelVal = $label.html();

          $input.on('change', function (e) {
            var fileName = '';

            if (e.target.value) {
              fileName = e.target.value.split('\\').pop();
            }

            if (fileName) {
              $label.find('span').html(fileName);
            } else {
              $label.html(labelVal);
            }
          });

          // Firefox bug fix
          $input
            .on('focus', function () {
              $input.addClass('has-focus');
            })
            .on('blur', function () {
              $input.removeClass('has-focus');
            });
        });

        $('trix-editor').attr('placeholder', 'Start typing...');

        $('.btn-reveal').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var target = $(this).attr('href');

          $(target).show();
          $(this).hide().remove();
        });

        $('form .toggle').on('change', function () {
          var toggled = '#' + $(this).data('toggled'),
            $toggled = $(toggled),
            $checked = $(this).prop('checked');

          if ($checked) {
            $toggled.show();
          } else {
            $toggled.hide();
          }
        });

        if ($('form .toggled').hasClass('has-error')) {
          $('form .toggled').show();
        }

        /* Show/Hide Password Fields */

        // if the show-password default is true, change the password visibility on page load
        var pw = $('input[name="show-password"]');
        pw.parent()
          .prev('input')
          .attr('type', pw.prop('checked') ? 'text' : 'password');

        // if the show-password checkbox is toggled, update pw visibility
        $('input[name="show-password"]').on('click', function () {
          $(this)
            .parent()
            .prev('input')
            .attr('type', $(this).prop('checked') ? 'text' : 'password');
        });

        // convert back into password type before submission
        $('form').on('submit', function () {
          $('input[name="show-password"]').parent().prev('input').attr('type', 'password');
        });

        // Sets "select all" functionality for toggleable multiple checkbox fields
        $('form').on('change', '.toggle-all-checkboxes input', function () {
          $(this)
            .closest('.checkboxmultipleselect')
            .find('.checkboxes input')
            .prop('checked', $(this).prop('checked'));
        });

        // Handles the password strength feedback on password inputs.
        var password_strength = {
          0: { label: 'Bad', class: 'progress-bar-danger' },
          1: { label: 'Bad', class: 'progress-bar-danger' },
          2: { label: 'Weak', class: 'progress-bar-warning' },
          3: { label: 'Good', class: 'progress-bar-info' },
          4: { label: 'Strong', class: 'progress-bar-success' },
        };

        $('.newpasswordwidget').each(function () {
          var $password_field = $(this).find('input[type="password"]'),
            $meter = $(this).find('.progress-bar'),
            $status = $(this).find('.progress-status');

          $password_field.on('input', function () {
            var val = $(this).val();
            var result = zxcvbn(val);

            // Update the text indicator
            if (val !== '') {
              $meter.text(password_strength[result.score].label);
              if (result.feedback.warning) {
                // removed feedback.suggestions for misspellings
                $status.html("<span class='feedback'>" + result.feedback.warning + '</span><br>');
              } else {
                $status.html('');
              }
              $meter.removeClass();
              $meter.addClass('progress-bar ' + password_strength[result.score]['class']);
              if (result.score) {
                $meter.width((result.score / 4) * 100 + '%');
              }
            } else {
              $status.html('');
              $meter.text('');
              $meter.width(0);
              $meter.removeClass();
              $meter.addClass('progress-bar');
            }
          });
        });

        var tel_inputs = document.querySelectorAll('input[type=tel]');
        for (var i = 0; i < tel_inputs.length; i++) {
          intlTelInput(tel_inputs[i], {
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/15.0.2/js/utils.js',
          });
        }

        $('.remaining-attachments').on('click', function (e) {
          e.preventDefault();

          $(this).parent().find('.hidden-media').first().ekkoLightbox();
        });

        $('[data-character-limit]').each(function () {
          $(this).after(
            '<span class="character-count">Characters remaining: <span class="current-count">' +
              $(this).data('character-limit') +
              '</span></span>'
          );
          ODESSA.common.updateCharacterCount($(this), $(this).data('character-limit'));
        });

        $('[data-character-limit]').on('keyup change', function () {
          ODESSA.common.updateCharacterCount($(this), $(this).data('character-limit'));
        });

        if ($('form').find('.has-error').length) {
          $('html,body').animate(
            {
              scrollTop: $('form').find('.has-error').first().offset().top - 70,
            },
            1000
          );
        }

        $('.box-commands').on('click', 'a', function (e) {
          e.preventDefault();

          $('.box-commands')
            .parent()
            .append('<span class="loading-message">Running ' + $(this).text() + ' command</span>');

          $.getJSON($(this).attr('href'), function (data) {
            $('.box-commands').parent().find('.loading-message').remove();
            if ($.isEmptyObject(data)) {
              alert('The command was executed successfully.');
            } else {
              alert(JSON.stringify(data, null, 2));
            }
          }).fail(function () {
            $('.box-commands').parent().find('.loading-message').remove();
            alert('An error occurred.');
          });
        });

        $('.reboot-all-boxes').on('click', function (e) {
          e.preventDefault();

          var $link = $(this);
          var confirm = window.confirm(
            'Are you sure you want to reboot all LG boxes at this facility?'
          );

          if (confirm) {
            $link.prepend('<span class="loading-message">Running</span>');

            $.getJSON($link.attr('href'), function (data) {
              $link.find('.loading-message').remove();
              alert(JSON.stringify(data, null, 2));
            });
          }
        });

        // Croppable Image Field
        $('.croppable-image-field').each(function () {
          var $ci_field = $(this).find('.croppable-image'),
            $ci_input = $ci_field.find('.image-file-input input[type="file"]'),
            $ci_placeholder = $ci_field.find('.placeholder-field'),
            $ci_crop_type = $ci_input.data('crop-type') || '';

          // Configure the crop UI settings
          var ciUploadCrop = $ci_field.find('.image-crop-box').croppie({
            viewport: {
              width: parseInt($ci_input.data('crop-width')),
              height: parseInt($ci_input.data('crop-height')),
              type: $ci_crop_type,
            },
            boundary: {
              width: parseInt($ci_input.data('crop-width')),
              height: parseInt($ci_input.data('crop-height')),
            },
            enableOrientation: true,
          });

          // Handle a rotation request
          $ci_field.find('.image-rotate').on('click', function (e) {
            e.preventDefault();
            ciUploadCrop.croppie('rotate', 90);
          });

          $ci_field.on('click', '.helper-image', function () {
            $ci_input.trigger('click');
          });

          // Handle when the file input has changed
          $ci_input.on('change', function () {
            if ($(this).val()) {
              ODESSA.common.readImageInputFile($ci_field, this, ciUploadCrop);
            } else {
              ODESSA.common.hideCropBox($ci_field);
            }
          });

          // Clear out the uploaded file
          $ci_field.on('click', '.btn-cancel', function (e) {
            e.preventDefault();
            $ci_input.val('');
            $ci_placeholder.val('');
            ODESSA.common.hideCropBox($ci_field);
          });

          // Crop the image and process result
          $ci_field.on('click', '.btn-crop', function (e) {
            e.preventDefault();

            $ci_field.find('.clear-checkbox').prop('checked', false);

            // Use canvas image to show as preview
            ciUploadCrop
              .croppie('result', {
                type: 'canvas',
              })
              .then(function (resp) {
                $ci_field.find('.image-current').removeClass('no-image');
                $ci_field.find('.image-current img').attr('src', resp);
                $ci_placeholder.val(resp);
                ODESSA.common.hideCropBox($ci_field);
              });
          });

          // On change
          $ci_field
            .on('click', '.btn-clear', function () {
              $ci_input.val('');
              $ci_placeholder.val('');
              $ci_field.find('.image-file-input span').text('');
              $ci_field.find('.image-current img').attr('src', '');
              $ci_field.find('.image-current').addClass('no-image');
              $ci_field.removeClass('has-image');
              $ci_field.find('.clear-checkbox').prop('checked', true);
            })
            .on('click', '.btn-edit', function () {
              ciUploadCrop.croppie('bind', {
                // Important to add the query value at the end of the image path
                // see: https://serverfault.com/questions/856904/chrome-s3-cloudfront-no-access-control-allow-origin-header-on-initial-xhr-req
                url: $ci_field.find('.image-current img').attr('src') + '?x-request=ajax',
              });
              $ci_field.removeClass('has-image');
              $ci_field.find('.image-crop-box').addClass('ready');
              $('body').append('<div class="croppie-focus-container"></div>');
              $ci_field.addClass('cropping');
            });
        });

        var options = {
          valueNames: [
            'name',
            { attr: 'data-timestamp', name: 'created' },
            { attr: 'data-timestamp', name: 'completed' },
            'screening',
          ],
        };

        new List('completed-screenings', options);

        // Sidebar toggle functionality
        $('#sidebarCollapseBtn').on('click', function () {
          $('.sidebar').toggleClass('collapsed');
          $('.collapse-icon, .expand-icon').toggleClass('d-none');
          $('main').toggleClass('expanded').toggleClass('col-md-10');
        });

        // Reset sidebar state on window resize
        $(window).on('resize', function () {
          if ($(window).width() < 768) {
            $('.sidebar').removeClass('collapsed');
            $('main').removeClass('expanded');
            $('.collapse-icon').removeClass('d-none');
            $('.expand-icon').addClass('d-none');
          }
        });
      }, // common init

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },

      renderFormErrors: function (response, $form) {
        if (response.status === 400) {
          for (var field in response.responseJSON) {
            var $errorField = $form.find('input[name="' + field + '"]:visible:first');
            $errorField.parent().addClass('has-error');
            $errorField.after(
              '<p class="help-block error-text">' + response.responseJSON[field] + '</p>'
            );
          }
        }
      },

      setCookie: function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
      },

      getCookie: function (name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
          var cookies = document.cookie.split(';');
          for (var i = 0; i < cookies.length; i++) {
            var cookie = jQuery.trim(cookies[i]);
            if (cookie.substring(0, name.length + 1) === name + '=') {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
              break;
            }
          }
        }
        return cookieValue;
      },

      updateCharacterCount: function ($input, character_limit) {
        var $character_count_display = $input.next(),
          $character_current_count = $character_count_display.find('.current-count'),
          current_count = character_limit - $input.val().length,
          count_class = current_count >= 0 ? 'text-success' : 'text-danger';
        $character_current_count.text(current_count);
        $character_count_display.removeClass('text-success text-error').addClass(count_class);
        $input
          .closest('form')
          .find('input[type="submit"]')
          .prop('disabled', current_count < 0);
      },

      hideCropBox: function ($input_container) {
        $('.croppie-focus-container').remove();
        $input_container.find('.image-crop-box').removeClass('ready');
        $input_container.removeClass('cropping');
        $input_container.width('auto');
        if ($input_container.find('.image-current img').attr('src')) {
          $input_container.addClass('has-image');
        }
      },

      readImageInputFile: function ($input_container, input, cropObject) {
        if (input.files && input.files[0]) {
          var reader = new FileReader();
          reader.onload = function (e) {
            cropObject.croppie('bind', {
              url: e.target.result,
            });
            $input_container.find('.image-crop-box').addClass('ready');
            $('body').append('<div class="croppie-focus-container"></div>');
            $input_container.addClass('cropping');
            $input_container.width($input_container.find('.inputfile').data('crop-width'));
          };
          reader.readAsDataURL(input.files[0]);
        }
      },
    }, // common

    preferences: {
      init: function () {
        $('.toggle-checkbox').each(function () {
          $(this).prop(
            'checked',
            $(this).closest('.list-group').find('.activity-groups input').length ===
              $(this).closest('.list-group').find('.activity-groups input:checked').length
          );

          $(this).on('change', function () {
            $(this)
              .closest('.list-group')
              .find('.activity-groups input')
              .prop('checked', $(this).prop('checked'));
          });
        });

        $('.activity-groups').on('change', 'input', function () {
          $(this)
            .closest('.list-group')
            .find('.toggle-checkbox')
            .prop(
              'checked',
              $(this).closest('.list-group').find('.activity-groups input').length ===
                $(this).closest('.list-group').find('.activity-groups input:checked').length
            );
        });
      },
    },

    family_photos: {
      init: function () {
        FamilyPhotos.init(ODESSA); //
      },
    },

    patient_detail: {
      init: function () {
        const event = new Event('create_new_note');

        $('.new-note').on('click', function () {
          document.dispatchEvent(event);
        });

        var hash = window.location.hash;
        $(hash + '-tab').tab('show');

        if (hash) {
          var $activeMobileNavLabel = $('.mobile-nav [data-target="' + hash + '"]').text();
          $('.mobile-nav .dropdown-toggle').text($activeMobileNavLabel);
        }

        $('[data-toggle="tab"]').on('click', function () {
          var newHash = $(this).data('target');
          window.location.hash = newHash;
        });

        $('.mobile-nav [data-toggle="tab"]').on('click', function () {
          var $parent = $(this).closest('.mobile-nav');
          $parent.find('.dropdown-item').removeClass('active');
          $parent.find('.dropdown-toggle').text($(this).text());
        });

        $(window).on('hashchange', function () {
          var hash = window.location.hash;
          $(hash + '-tab').tab('show');
          $('html,body').animate({ scrollTop: 0 }, 500);
        });
      },
    },
    stb_list: {
      init: function () {
        var options = {
          valueNames: [
            'practicename',
            {
              attr: 'data-patient-name',
              name: 'patientname',
            },
            'boxtype',
            'boxid',
            {
              attr: 'data-timestamp',
              name: 'lastseen',
            },
            {
              attr: 'data-timestamp',
              name: 'lastreloaded',
            },
            'fwv',
            'ldv',
            'appv',
          ],
        };

        var mfcSTBList = new List('mfc-stb-table', options);

        $('select[name=practicelist]').on('change', function () {
          ODESSA.stb_list.applyFilters(mfcSTBList);
        });

        $('select[name=stbtypelist]').on('change', function () {
          ODESSA.stb_list.applyFilters(mfcSTBList);
        });
      },
      applyFilters: function (mfcSTBList) {
        var practice = $('select[name=practicelist]').val();
        var stbtype = $('select[name=stbtypelist]').val();

        if (practice && stbtype) {
          mfcSTBList.filter(function (item) {
            return item.values().practicename == practice && item.values().boxtype == stbtype;
          });
        } else {
          if (practice) {
            mfcSTBList.filter(function (item) {
              return item.values().practicename == practice;
            });
          } else if (stbtype) {
            mfcSTBList.filter(function (item) {
              return item.values().boxtype == stbtype;
            });
          } else {
            // No filters selected, reset the list
            mfcSTBList.filter();
          }
        }
      },
    },
    stb_releases: {
      init: function () {
        StbManagement.init();
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = ODESSA;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
